import { ReactNode } from 'react';

import { Auth0Provider } from '@auth0/auth0-react';

import { useAppDispatch, useAppSelector } from '@store/redux/store';
import { useHistory } from 'react-router-dom';
import { toggleOn } from '@store/redux/features/mixpanel';

interface IAuth0ProviderWithHistory {
  children: ReactNode;
}

interface IAuth0ProviderContent {
  children: ReactNode;
  orgId: string;
}

const Auth0ProviderContent = ({ children, orgId }: IAuth0ProviderContent) => {
  const domain = process.env.REACT_APP_AUTH0_DOMAIN as string;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID as string;
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE;
  const history = useHistory();
  const dispatch = useAppDispatch();
  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      redirectUri={window.location.origin}
      audience={audience}
      organization={orgId}
      useRefreshTokens
      onRedirectCallback={appState => {
        // workaround. Should have dedicated route.
        dispatch(toggleOn('User Logged In'));
        history.replace(appState.returnTo || window.location.pathname, {});
      }}
      // Keep cacheLocation as localstorage, see: https://app.clickup.com/t/3x5fkmc
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
};

const Auth0ProviderWithHistory = ({ children }: IAuth0ProviderWithHistory) => {
  const { organization } = useAppSelector();

  return (
    <Auth0ProviderContent orgId={organization.orgId}>
      {children}
    </Auth0ProviderContent>
  );
};

export { Auth0ProviderWithHistory };
